export default __webpack_public_path__ + "static/media/NaharTime.9169ba3d.ttf";